'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CredentialId$() {
  this.c4x = null;
  this.c4y = false;
}
export { $c_Lpresto_types$CredentialId$ as $c_Lpresto_types$CredentialId$ };
$p = $c_Lpresto_types$CredentialId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CredentialId$;
/** @constructor */
function $h_Lpresto_types$CredentialId$() {
}
export { $h_Lpresto_types$CredentialId$ as $h_Lpresto_types$CredentialId$ };
$h_Lpresto_types$CredentialId$.prototype = $p;
$p.gH = (function() {
  if ((!this.c4y)) {
    this.c4x = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.c4y = true;
  }
  return this.c4x;
});
var $d_Lpresto_types$CredentialId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CredentialId$, "presto.types$CredentialId$", ({
  YQ: 1,
  D: 1
}));
export { $d_Lpresto_types$CredentialId$ as $d_Lpresto_types$CredentialId$ };
var $n_Lpresto_types$CredentialId$;
function $m_Lpresto_types$CredentialId$() {
  if ((!$n_Lpresto_types$CredentialId$)) {
    $n_Lpresto_types$CredentialId$ = new $c_Lpresto_types$CredentialId$();
  }
  return $n_Lpresto_types$CredentialId$;
}
export { $m_Lpresto_types$CredentialId$ as $m_Lpresto_types$CredentialId$ };
//# sourceMappingURL=presto.types$-Credential-Id$.js.map
